<template>
  <div class="basic-info">
    <BaseHeaderBar title="Infomasi Dasar" :showCustomerService="false" :showBackButton="true" />
    <form class="form-content" @submit.prevent="onSubmit">
      <input v-model="name" type="text" maxlength="30" placeholder="Silakan masukkan nama"
        :disabled="disabledFields.name" @copy.prevent @cut.prevent @paste.prevent
        @focus="startFieldTracking('name', name)" @blur="finishFieldTracking('name', name)" />
      <input v-model.trim="ktp" type="tel" minlength="16" maxlength="20" placeholder="Silakan masukkan NIK KTP"
        :disabled="disabledFields.ktp" @copy.prevent @cut.prevent @paste.prevent @focus="startFieldTracking('ktp', ktp)"
        @blur="finishFieldTracking('ktp', ktp)" />
      <input v-model.trim="whatsApp" type="tel" minlength="9" maxlength="13"
        placeholder="Silakan masukkan nomor Whatsapp" @copy.prevent @cut.prevent @paste.prevent
        @focus="startFieldTracking('whatsApp', whatsApp)" @blur="finishFieldTracking('whatsApp', whatsApp)" />
      <input v-model.trim="mail" type="text" placeholder="Silakan masukkan email" @copy.prevent @cut.prevent
        @paste.prevent @focus="startFieldTracking('mail', mail)" @blur="finishFieldTracking('mail', mail)" />
      <div class="select-block">
        <input type="text" readonly :value="education" placeholder="Silakan pilih pendidikan"
          :disabled="disabledFields.education" @click="select('education')" @copy.prevent @cut.prevent @paste.prevent />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input type="text" readonly :value="marriage" placeholder="Silakan pilih status pernikahan"
          :disabled="disabledFields.marriage" @click="select('marriage')" @copy.prevent @cut.prevent @paste.prevent />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input type="text" readonly :value="incomeSource" placeholder="Silakan pilih sumber penghasilan"
          @click="select('incomeSource')" @copy.prevent @cut.prevent @paste.prevent />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input type="text" readonly :value="residence" placeholder="Silakan pilih tipe rumahk"
          @click="select('residence')" @copy.prevent @cut.prevent @paste.prevent />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input type="text" readonly :value="address" placeholder="Silakan pilih alamat tempat tinggal"
          @click="openAddressSelector" @copy.prevent @cut.prevent @paste.prevent />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <input v-model.trim="addressDetail" type="text" maxlength="30"
        placeholder="Silakan masukkan alamat lengkap tempat tinggal" @copy.prevent @cut.prevent @paste.prevent
        @focus="startFieldTracking('addressDetail', addressDetail)"
        @blur="finishFieldTracking('addressDetail', addressDetail)" />
      <div class="select-block">
        <input type="text" readonly :value="loanUse" placeholder="Silakan pilih tujuan pinjaman"
          @click="select('loanUse')" @copy.prevent @cut.prevent @paste.prevent />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input type="text" readonly :value="annualIncome" placeholder="Silakan pilih pemasukan tahunan"
          @click="select('annualIncome')" @copy.prevent @cut.prevent @paste.prevent />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input type="text" readonly :value="profession" placeholder="Silakan pilih jenis pekerjaan"
          @click="select('profession')" @copy.prevent @cut.prevent @paste.prevent />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <div class="select-block">
        <input type="text" readonly :value="industry" placeholder="Silakan pilih industri pekerjaan"
          @click="select('industry')" @copy.prevent @cut.prevent @paste.prevent />
        <img src="@/assets/img/arrow-down.png" class="arrow-down" />
      </div>
      <input v-if="profession != 'Murid' && profession != 'Tidak bekerja'" v-model.trim="codrmpanyName" type="text"
        maxlength="30" placeholder="Silakan masukkan nama toko atau perusahaan" @copy.prevent @cut.prevent
        @paste.prevent @focus="startFieldTracking('codrmpanyName', codrmpanyName)"
        @blur="finishFieldTracking('codrmpanyName', codrmpanyName)" />
      <input v-if="profession != 'Murid' && profession != 'Tidak bekerja'" v-model.trim="codrmpanyAddress" type="text"
        maxlength="30" placeholder="Silakan masukkan alamat lengkap toko atau perusahaan" @copy.prevent @cut.prevent
        @paste.prevent @focus="startFieldTracking('codrmpanyAddress', codrmpanyAddress)"
        @blur="finishFieldTracking('codrmpanyAddress', codrmpanyAddress)" />
      <p class="desc">
        Silakan pilih 3 nomor berbeda dari daftar kontak Anda yang dapat
        dihubungi kapan pun, baik kerabat/teman/nomor pribadi lainnya untuk
        ditambahkan sebagai kontak darurat. Kontak darurat hanya digunakan untuk
        keperluan evaluasi.
      </p>
      <div v-for="n in 3" :key="n">
        <div class="select-block">
          <input type="text" readonly :value="contact[n - 1].contactRelationship"
            placeholder="Silakan pilih hubungan dengan kontak darurat" @click="select('contact', n - 1)" @copy.prevent
            @cut.prevent @paste.prevent />
          <img src="@/assets/img/arrow-down.png" class="arrow-down" />
        </div>
        <input v-show="contact[n - 1].contactName" v-model.trim="contact[n - 1].contactName" type="text"
          placeholder="Silakan Masukkan Nama Kontak Darurat" @input="handleInput($event, n - 1)" @copy.prevent
          @cut.prevent @paste.prevent readonly
          @focus="startFieldTracking('contactName' + n, contact[n - 1].contactName)"
          @blur="finishFieldTracking('contactName' + n, contact[n - 1].contactName)" />
        <div class="select-block">
          <input v-model.trim="contact[n - 1].contactPhone" type="tel" maxlength="13"
            placeholder="Masukkan nomor telepon dengan awalan 08" @copy.prevent @cut.prevent @paste.prevent readonly
            @focus="startFieldTracking('contactPhone' + n, contact[n - 1].contactPhone)"
            @blur="finishContactPhoneTracking(n)" @click="toAddressBook(n)" />
          <img src="@/assets/img/arrow-down.png" class="arrow-down" />
        </div>
      </div>
      <button type="button" class="confirm-btn" @click="onSubmit">Kirim</button>
    </form>
    <van-popup v-model="visible" round position="bottom" @closed="onPickerClosed">
      <van-picker show-toolbar :columns="columns[curSelectedKey]" cancel-button-text="Batal" confirm-button-text="Yakin"
        @cancel="onCancel" @confirm="onConfirm" />
    </van-popup>
    <van-popup v-model="addressVisible" round position="bottom" @closed="onAddressClosed">
      <van-cascader v-model="cascaderValue" title="Silakan pilih alamat tempat tinggal" placeholder="Silakan pilih"
        :options="addressOptions" @close="onCloseDialog('addressVisible')" @change="onAddressChange"
        @finish="onFinish" />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'
import { Popup, Picker, Cascader, Toast } from 'vant'
import { validatePhoneNumber, validateEmail, validateContactPhone } from '@/utils/validator'
import request from '@/utils/request'
import dialogVisible from '@/mixins/dialogVisible'
import {
  createFormTracking,
  finishFormFieldTracking,
  getFormTrackingData,
  resetFormTracking,
  startFormFieldTracking
} from '@/utils/formTracking'

Vue.use(Popup)
Vue.use(Picker)
Vue.use(Cascader)
Vue.use(Toast)

let ktpStatus

const trackingFieldMap = {
  name: 'name',
  ktp: 'ktp',
  whatsApp: 'whatsapp',
  mail: 'email',
  education: 'education',
  marriage: 'marital',
  incomeSource: 'income',
  residence: 'residence',
  address: 'residentialarea',
  addressDetail: 'address',
  profession: 'worktype',
  industry: 'workindustry',
  annualIncome: 'yearincome',
  loanUse: 'usefunds',
  codrmpanyName: 'companyname',
  codrmpanyAddress: 'companyaddress'
}

for (let i = 1; i <= 3; i++) {
  trackingFieldMap[`contactName${i}`] = `name${i}`
  trackingFieldMap[`contactRelationship${i}`] = `relation${i}`
  trackingFieldMap[`contactPhone${i}`] = `phone${i}`
}

export default {
  name: 'BasicInfo',
  mixins: [dialogVisible],
  data () {
    return {
      name: '',
      ktp: '',
      whatsApp: '',
      mail: '',
      addressDetail: '',
      codrmpanyName: '',
      codrmpanyAddress: '',
      education: '',
      marriage: '',
      incomeSource: '',
      residence: '',
      loanUse: '',
      annualIncome: '',
      profession: '',
      industry: '',
      contact: [
        {
          contactRelationship: '',
          contactName: '',
          contactPhone: ''
        },
        {
          contactRelationship: '',
          contactName: '',
          contactPhone: ''
        },
        {
          contactRelationship: '',
          contactName: '',
          contactPhone: ''
        }
      ],
      address: '',
      columns: {
        education: [],
        marriage: [],
        incomeSource: [],
        residence: [],
        loanUse: [],
        annualIncome: [],
        profession: [],
        industry: [],
        contact: []
      },
      cascaderValue: '',
      addressOptions: [],
      curSelectedKey: '',
      contactIndex: null,
      addressBookTrackingIndex: null,
      disabledFields: {
        name: false,
        ktp: false,
        education: false,
        marriage: false
      },
      addressVisible: false,
      tracking: createFormTracking(trackingFieldMap),
      shouldResetTracking: false
    }
  },
  computed: mapState(['userInfo']),
  created () {
    this.getBasicInfo()
    this.getProvince()
  },
  methods: {
    resetTracking () {
      resetFormTracking(this.tracking, trackingFieldMap)
    },
    startFieldTracking (field, value) {
      startFormFieldTracking(this.tracking, field, value)
    },
    finishFieldTracking (field, value) {
      finishFormFieldTracking(this.tracking, field, value)
    },
    getTrackingData () {
      const trackingData = getFormTrackingData(this.tracking, trackingFieldMap)
      if (this.profession === 'Murid' || this.profession === 'Tidak bekerja') {
        trackingData.companyname_duration = 0
        trackingData.companyname_revisenum = 0
        trackingData.companyname_reviseduration = 0
        trackingData.companyaddress_duration = 0
        trackingData.companyaddress_revisenum = 0
        trackingData.companyaddress_reviseduration = 0
      }
      return trackingData
    },
    getContactTrackingField (index, key) {
      return `contact${key}${index + 1}`
    },
    getContactTrackingValue (field) {
      const matched = field.match(/^contact(Name|Relationship|Phone)(\d)$/)
      if (!matched) return ''
      const contactItem = this.contact[Number(matched[2]) - 1]
      if (!contactItem) return ''
      const valueKey = `contact${matched[1]}`
      return contactItem[valueKey]
    },
    getSelectTrackingField (key, index) {
      if (key === 'contact') {
        return this.getContactTrackingField(index, 'Relationship')
      }
      return key
    },
    getTrackingValue (field) {
      if (field.indexOf('contact') === 0) {
        return this.getContactTrackingValue(field)
      }
      return this[field]
    },
    finishCurrentPickerTracking () {
      if (!this.curSelectedKey) return
      const field = this.getSelectTrackingField(this.curSelectedKey, this.contactIndex)
      this.finishFieldTracking(field, this.getTrackingValue(field))
      this.curSelectedKey = ''
      this.contactIndex = null
    },
    finishContactPhoneTracking (index) {
      const contactIndex = index - 1
      if (this.addressBookTrackingIndex === contactIndex) return
      const field = this.getContactTrackingField(contactIndex, 'Phone')
      this.finishFieldTracking(field, this.getContactTrackingValue(field))
    },
    finishAddressBookTracking (index) {
      const nameField = this.getContactTrackingField(index, 'Name')
      const phoneField = this.getContactTrackingField(index, 'Phone')
      this.finishFieldTracking(nameField, this.getContactTrackingValue(nameField))
      this.finishFieldTracking(phoneField, this.getContactTrackingValue(phoneField))
      this.addressBookTrackingIndex = null
    },
    handleAddressBookReturn (query) {
      const { userphone, username, number } = query
      if (userphone) {
        const contactIndex = Number(number)
        this.contact[contactIndex].contactPhone = userphone
        this.contact[contactIndex].contactName = username || userphone
        this.finishAddressBookTracking(contactIndex)
      } else if (this.addressBookTrackingIndex !== null) {
        this.finishAddressBookTracking(this.addressBookTrackingIndex)
      }
    },
    hasReflectValue (value) {
      return value !== null && value !== undefined && value !== ''
    },
    getBasicInfo () {
      request.post('badrsicInfoPage')
        .then(res => {
          this.name = res.cudrstomerName
          this.ktp = res.cudrstomerIdcard
          this.education = res.cudrstomerEducation
          this.marriage = res.cudrstomer_marrystatus
          this.disabledFields.name = this.hasReflectValue(res.cudrstomerName)
          this.disabledFields.ktp = this.hasReflectValue(res.cudrstomerIdcard)
          this.disabledFields.education = this.hasReflectValue(res.cudrstomerEducation)
          this.disabledFields.marriage = this.hasReflectValue(res.cudrstomer_marrystatus)
          this.columns = {
            education: res.eddrucationList,
            marriage: res.madrrrystatusList,
            incomeSource: res.indrcomesourceList,
            residence: res.redrsidencetypeList,
            loanUse: res.usdreoffundsList,
            annualIncome: res.yedrarincomeList,
            profession: res.wodrrktypeList,
            industry: res.wodrrkindustryList,
            contact: res.redrlationshipList
          }
          ktpStatus = res.ktdrp_status
        })
    },
    getProvince () {
      request.post('obdrProvince')
        .then(res => {
          this.addressOptions = res.lidrst.map(item => (
            {
              text: item.prdrovincesName,
              value: item.p_id,
              children: []
            }
          ))
          this.getCity(this.addressOptions[0], res.lidrst[0].p_id).then(cityList => {
            this.getCounty(this.addressOptions[0].children[0], cityList[0].cdrID)
          })
        })
    },
    getCity (option, provinceId) {
      const postData = {
        pdrID: provinceId
      }
      return request.post('obdrCity', postData)
        .then(res => {
          option.children = res.lidrst.map(item => (
            {
              text: item.cidrtyName,
              value: item.cdrID,
              children: []
            }
          ))
          return res.lidrst
        }).catch(e => {
          throw e
        })
    },
    getCounty (option, cityId) {
      const postData = {
        cdrID: cityId
      }
      request.post('obdrCounty', postData)
        .then(res => {
          option.children = res.lidrst.map(item => (
            {
              text: item.codruntyName,
              value: item.c_id
            }
          ))
        })
    },
    validateContactPhone (contactPhone) {
      if (!contactPhone) {
        Toast('Masukkan nomor telepon dengan awalan 08')
        return false
      }
      if (!validateContactPhone(contactPhone)) {
        Toast('Format nomor telepon kontak salah')
        return false
      }
      if (contactPhone === this.userInfo.usdrerMobile) {
        Toast('Nomor kontak darurat tidak boleh sama dengan nomor pendaftaran')
        return false
      }
      if (this.contact.filter(item => item.contactPhone === contactPhone).length > 1) {
        Toast('Kedua nomor kontak darurat tidak boleh sama')
        return false
      }
      return true
    },
    validate () {
      if (!this.name) {
        Toast('Silakan masukkan nama')
        return false
      }
      if (!/^[A-Za-z\s]+$/.test(this.name)) {
        Toast('Format nama salah')
        return false
      }
      if (!this.ktp) {
        Toast('Silakan masukkan NIK KTP')
        return false
      }
      if (!/^\d{16,20}$/.test(this.ktp)) {
        Toast('Format NIK salah')
        return false
      }
      if (!this.whatsApp) {
        Toast('Silakan masukkan nomor Whatsapp')
        return false
      }
      if (!validatePhoneNumber(this.whatsApp)) {
        Toast('Format Whatsapp salah')
        return false
      }
      if (!this.mail) {
        Toast('Silakan masukkan email')
        return false
      }
      if (!validateEmail(this.mail)) {
        Toast('Format email salah')
        return false
      }
      if (!this.education) {
        Toast('Silakan pilih pendidikan')
        return false
      }
      if (!this.marriage) {
        Toast('Silakan pilih status pernikahan')
        return false
      }
      if (!this.incomeSource) {
        Toast('Silakan pilih sumber penghasilan')
        return false
      }
      if (!this.residence) {
        Toast('Silakan pilih tipe rumah')
        return false
      }
      if (!this.address) {
        Toast('Silakan pilih alamat tempat tinggal')
        return false
      }
      if (!this.addressDetail) {
        Toast('Silakan masukkan alamat lengkap tempat tinggal')
        return false
      }
      if (!this.loanUse) {
        Toast('Silakan pilih tujuan pinjaman')
        return false
      }
      if (!this.annualIncome) {
        Toast('Silakan pilih pemasukan tahunan')
        return false
      }
      if (!this.profession) {
        Toast('Silakan pilih jenis pekerjaan')
        return false
      }
      if (!this.industry) {
        Toast('Silakan pilih industri pekerjaan')
        return false
      }
      if (this.profession !== 'Murid' && this.profession !== 'Tidak bekerja') {
        if (!this.codrmpanyName) {
          Toast('Silakan masukkan nama toko atau perusahaan')
          return false
        }
        if (!this.codrmpanyAddress) {
          Toast('Silakan masukkan alamat lengkap toko atau perusahaan')
          return false
        }
      }

      for (let i = 0; i < this.contact.length; i++) {
        if (!this.contact[i].contactRelationship) {
          Toast('Silakan pilih hubungan dengan kontak darurat')
          return false
        }
        if (!this.contact[i].contactName) {
          Toast('Silakan Masukkan Nama Kontak Darurat')
          return false
        }
        if (!this.validateContactPhone(this.contact[i].contactPhone)) {
          return false
        }
      }
      return true
    },
    toAddressBook (index) {
      const contactIndex = index - 1
      const nameField = this.getContactTrackingField(contactIndex, 'Name')
      const phoneField = this.getContactTrackingField(contactIndex, 'Phone')
      this.addressBookTrackingIndex = contactIndex
      this.startFieldTracking(nameField, this.getContactTrackingValue(nameField))
      this.startFieldTracking(phoneField, this.getContactTrackingValue(phoneField))
      this.$router.push({
        path: '/addressBook',
        query: {
          number: contactIndex,
          contact: JSON.stringify(this.contact)
        }
      })
    },
    select (key, index) {
      if (this.disabledFields[key]) return
      this.curSelectedKey = key
      index !== undefined && (this.contactIndex = index)
      const field = this.getSelectTrackingField(key, index)
      this.startFieldTracking(field, this.getTrackingValue(field))
      this.visible = true
    },
    onSubmit () {
      if (!this.validate()) return
      if (this.flag) return
      this.flag = true
      const trackingData = this.getTrackingData()
      const postData = {
        usdrerName: this.name,
        usdrerIdcard: this.ktp,
        usdrerWhatsapp: this.whatsApp,
        usdrerEmail: this.mail,
        usdrerEducation: this.education,
        usdrerMarrystatus: this.marriage,
        usdrerIncomesource: this.incomeSource,
        usdrerResidencetype: this.residence,
        usdrerResidentialarea: this.address,
        usdrerAddress: this.addressDetail,
        usdrerWorktype: this.profession,
        usdrerWorkindustry: this.industry,
        usdrerYearincome: this.annualIncome,
        usdrerUseoffunds: this.loanUse,
        ktdrpStatus: ktpStatus,
        codrmpanyAddress: this.codrmpanyAddress,
        codrmpanyName: this.codrmpanyName,
        codrntactList: JSON.stringify(this.contact)
      }
      request.post('badrsicInfosubmit', postData)
        .then(() => {
          return request.post('basicInfoTracking', trackingData).catch(() => false)
        })
        .then(() => {
          Toast('Pembaruan infomasi dasar berhasil')
          this.$router.back()
        }).finally(() => {
          this.flag = false
        })
    },
    onCancel () {
      this.finishCurrentPickerTracking()
      this.onCloseDialog()
    },
    onConfirm (value) {
      console.log(value)
      if (this.curSelectedKey === 'contact') {
        this.contact[this.contactIndex].contactRelationship = value
      } else {
        this[this.curSelectedKey] = value
      }
      this.finishCurrentPickerTracking()
      this.onCloseDialog()
    },
    onPickerClosed () {
      this.finishCurrentPickerTracking()
    },
    openAddressSelector () {
      this.startFieldTracking('address', this.address)
      this.addressVisible = true
    },
    onAddressChange ({ value, selectedOptions, tabIndex }) {
      if (tabIndex === 0) {
        if (!selectedOptions[0].children.length) {
          this.getCity(selectedOptions[0], value).then(cityList => {
            this.getCounty(selectedOptions[0].children[0], cityList[0].cdrID)
          })
        }
      } else if (tabIndex === 1) {
        if (!selectedOptions[1].children.length) {
          this.getCounty(selectedOptions[1], value)
        }
      }
    },
    onFinish ({ selectedOptions }) {
      this.address = selectedOptions.map(option => option.text).join('/')
      this.finishFieldTracking('address', this.address)
      this.onCloseDialog('addressVisible')
    },
    onAddressClosed () {
      this.finishFieldTracking('address', this.address)
      this.onCloseDialog('addressVisible')
    },
    // 限制不能输入除字母以外得字符
    handleInput (event, index) {
      const filteredText = event.target.value.replace(/[^a-zA-Z]/g, '')
      this.contact[index].contactName = filteredText
    }
  },
  activated () {
    if (this.shouldResetTracking) {
      this.resetTracking()
      this.shouldResetTracking = false
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.handleAddressBookReturn(to.query)
    })
  },
  beforeRouteUpdate (to, from, next) {
    this.handleAddressBookReturn(to.query)
    next()
  },
  beforeRouteLeave (to, from, next) {
    this.shouldResetTracking = to.path !== '/addressBook'
    next()
  }
}
</script>

<style scoped lang="less">
.basic-info {
  background: url("../assets/img/page_back.png") no-repeat;
  background-size: 100% 100%;
  padding-bottom: 48px;
}

.form-content {
  margin-top: 350px;
  padding-left: 30px;
  padding-right: 30px;
}

input {
  display: block;
  width: 100%;
  height: 94px;
  line-height: 94px;
  border: none;
  border-radius: 47px;
  padding-left: 20px;
  box-sizing: border-box;
  background-color: #fff;
  font-weight: 500;
  font-size: 32px;
  color: #4bc4b3;

  &:nth-child(n + 2) {
    margin-top: 30px;
  }

  &::placeholder {
    font-size: 26px;
    color: #d1d2dd;
  }
}

.select-block {
  position: relative;
  margin-top: 32px;

  .arrow-down {
    position: absolute;
    top: 50%;
    right: 30px;
    width: 31px;
    height: 20px;
    transform: translateY(-50%);
  }
}

.desc {
  margin-top: 30px;
  margin-bottom: 39px;
  font-size: 26px;
  font-weight: 500;
  color: #ffffff;
  line-height: 40px;
}

.confirm-btn {
  .submit-btn;
  margin-top: 48px;
}
</style>
